import { optimize } from 'ml-spectra-fitting';
import { xGetFromToIndex } from 'ml-spectra-processing';
import { groupPeaks } from './groupPeaks';
export function optimizePeaks(data, peakList, options = {}) {
    const { factorWidth = 1, factorLimits = 2, shape = {
        kind: 'gaussian',
        width: 0,
    }, optimization = {
        kind: 'lm',
        options: {
            timeout: 10,
        },
    }, } = options;
    if (data.x[0] > data.x[1]) {
        data.x.reverse();
        data.y.reverse();
    }
    let groups = groupPeaks(peakList, factorWidth);
    let results = [];
    groups.forEach((peaks) => {
        const firstPeak = peaks[0];
        const lastPeak = peaks[peaks.length - 1];
        const from = firstPeak.x - firstPeak.shape.width * factorLimits;
        const to = lastPeak.x + lastPeak.shape.width * factorLimits;
        const { fromIndex, toIndex } = xGetFromToIndex(data.x, { from, to });
        // Multiple peaks
        const currentRange = {
            x: data.x.slice(fromIndex, toIndex),
            y: data.y.slice(fromIndex, toIndex),
        };
        if (currentRange.x.length > 5) {
            let { peaks: optimizedPeaks } = optimize(currentRange, peaks, {
                shape,
                optimization,
            });
            results = results.concat(optimizedPeaks);
            // eslint-disable-next-line curly
        }
        else
            results = results.concat(peaks);
    });
    return results;
}
//# sourceMappingURL=optimizePeaks.js.map